export default onHydrationEnd;

function onHydrationEnd() {
  console.log('Hydration finished; page is now interactive.');

  const body = typeof document !== 'undefined' && document.querySelector('body');

  body!.classList.add('page-is-interactive');
}
